import http from '../http/http';

var DataSource = function(config) {
    if (typeof config === 'string') {
        config = { url: config, try: null, transform: null };
    }
    return {
        finish: false,
        data: [],
        empty: false,
        loading: false,
        total: config.total ? config.total : 0,
        params: {
            step: 50,
            page: 0,
            ...config.params
        },
        reload: function() {
            this.empty = false;
            this.data = [];
            this.params.page = 0;
            this.finish = false;
            this.next();
        },
        load: function() {
            if (this.params.page > 0) {
                this.params.page -= 1;
            }
            this.data = [];
            this.next();
        },
        next: function() {
            this.loading = true;
            this.params.page += 1;
            var me = this;
            if (config.data) {
                setTimeout(function() {
                    me.loading = false;
                    var data = config.data();
                    me.data.length = 0;
                    data.forEach(function(element) {
                        me.data.push(element);
                    });
                }, 300);
            } else {
                http.post(config.url, me.params)
                    .then(function(response) {
                        me.loading = false;
                        var data = response;
                        if (!(response instanceof Array)) {
                            data = response.data;
                            me.total = response.total;
                        }
                        if (data.length == 0) {
                            if (me.data.length == 0) {
                                me.empty = true;
                            }
                            me.finish = true;
                            return;
                        }
                        if (typeof response.is_request != 'undefined') {
                            if (response.is_request == 2) {
                                me.finish = true;
                            }
                        } else {
                            me.finish = data.length < me.params.step ? true : false;
                        }
                        for (var i in data) {
                            me.data.push(data[i]);
                        }
                    })
                    .catch(function(error) {
                        me.loading = false;
                        console.log(error);
                    });
            }
        },
        search: function(params) {
            this.params = {
                step: this.params.step,
                page: 0
            };
            for (var key in params) {
                this.params[key] = params[key];
                Vue.set(this.params, key, params[key]);
            }
            this.reload();
        },
        andSearch: function(params) {
            for (var key in params) {
                Vue.set(this.params, key, params[key]);
            }
            this.reload();
        }
    };
};

var getCurDate = function(type) {
    // 2020-02-09
    var year = new Date().getFullYear();
    var month = new Date().getMonth() + 1;
    var day = new Date().getDate();
    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
    if (type === 'Array') {
        return [year, month, day];
    } else {
        return year + '-' + month + '-' + day;
    }
};

//获取n天前的日期
var findDate = function (num) {
    var date1 = new Date();
    //今天时间
    var date2 = new Date(date1);
    date2.setDate(date1.getDate() + num);
    //num是正数表示之后的时间，num负数表示之前的时间，0表示今天
    var month = date2.getMonth() + 1;
    var day = date2.getDate();
    if(month<10){
        month = "0" +month;
    }
    if(day<10){
        day = "0" +day;
    }
    var time2 = date2.getFullYear() + "-" + month + "-" + day;
    return time2;
};

//获取上个月日期
/**
 * @param now 当前日期 格式:yyyy-MM
 * @param addMonths 传-1 上个月,传1 下个月
 */
var getNextMonth = function (now,addMonths) {
	var dd = new Date(now);
	var m = dd.getMonth() + 1;
	var y = dd.getMonth() + 1 + addMonths > 12 ? (dd.getFullYear() + 1) : dd.getFullYear();
	if (m + addMonths == 0){
		y = y - 1;
		m = 12;
	}else {
		if (m + addMonths > 12){
			m = '01';
		}else {
            m = m + addMonths;
            if(m < 10) m = '0' + m;
        }
    }
	return y + "-" + m;
};


var numToText = function(str) {
    var num = parseFloat(str);
    var strOutput = '',
        strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分';
    num += '00';
    var intPos = num.indexOf('.');
    if (intPos >= 0) {
        num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
    }
    strUnit = strUnit.substr(strUnit.length - num.length);
    for (var i = 0; i < num.length; i++) {
        strOutput += '零壹贰叁肆伍陆柒捌玖'.substr(num.substr(i, 1), 1) + strUnit.substr(i, 1);
    }
    return strOutput
        .replace(/零角零分$/, '整')
        .replace(/零[仟佰拾]/g, '零')
        .replace(/零{2,}/g, '零')
        .replace(/零([亿|万])/g, '$1')
        .replace(/零+元/, '元')
        .replace(/亿零{0,3}万/, '亿')
        .replace(/^元/, '零元');
};

var moneyFormat = function(money){
    if (money && money != null) {
        money = String(money);
        var left = money.split('.')[0],
            right = money.split('.')[1];
        right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00';
        var temp = left
            .split('')
            .reverse()
            .join('')
            .match(/(\d{1,3})/g);
        return (
            (Number(money) < 0 ? '-' : '') +
            temp
                .join(',')
                .split('')
                .reverse()
                .join('') +
            right
        );
    } else if (money === 0) {
        return '0.00';
    } else {
        return '';
    }
}

export default {
    DataSource,
    getCurDate,
    numToText,
    findDate,
    getNextMonth,
    moneyFormat
};
